import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a8b69a40"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-last ba-column-title ba-text ba-text-right"
};
const _hoisted_2 = {
  class: "previous ba-text"
};
const _hoisted_3 = {
  class: "ba-double-content",
  style: {
    "color": "#93999F !important"
  }
};
const _hoisted_4 = {
  class: "ba-double-content-inner",
  style: {
    "color": "unset !important",
    "flex-direction": "column"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_calendar_with_arrow_left_icon = _resolveComponent("calendar-with-arrow-left-icon");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_flex_row, {
    gap: 3,
    id: $props.item_id
  }, {
    default: _withCtx(() => [_createVNode(_component_calendar_with_arrow_left_icon), _createVNode(_component_currency_value, {
      value: $props.previous_week_value,
      currency: $props.currency,
      precision: $props.currency_precision,
      allowPrecisionModification: false
    }, null, 8, ["value", "currency", "precision"])]),
    _: 1
  }, 8, ["id"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_currency_value, {
    value: $props.value,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false,
    showSign: "",
    class: _normalizeClass(["ba-text", {
      'ba-text-red': $props.value < 0,
      'ba-text-green': $props.value > 0
    }])
  }, null, 8, ["value", "currency", "precision", "class"])]), _createVNode(_component_app_popover, {
    target: $props.item_id,
    "auto-width": "",
    placement: "left"
  }, {
    default: _withCtx(() => [_createTextVNode(" Last week's spend ")]),
    _: 1
  }, 8, ["target"])])])]);
}